import MdDialogPrompt from "./MdDialogPrompt"

const MdDialogPromptPlugin = {
  install(app) {
    app.component(MdDialogPrompt.name, MdDialogPrompt)
  },
}

export default MdDialogPromptPlugin
